<script>
    import { onMount } from 'svelte';
    import { MDCTextField } from '@material/textfield';
    import { MDCTextFieldFoundation } from '@material/textfield'


    // component options  ------------------------------------------------------ //

    export let label;
    export let max_chars;
    export let rows = "3";
    export let cols = "40";
    export let additional_class = false;
    export let value;
    export let show_counter = true;
    export let disable_resize = true;
    export let width;
    export let height = "120px";
    export let single_row = false;
    export let placeholder = '';
    export let id = "text-field";
    export let variant = 'outlined'

    let textarea;
    let textarea_value;
    let val;

    // export let value = null;


    // utility functions -------------------------------------------------------- //

    const init_text_field = () => {
      let element = document.querySelector('.text_field');
      if (!!element) {
        textarea = new MDCTextField(document.getElementById(id));
      }
    };

    onMount(init_text_field);
</script>

<style>
    .additional_class {
        margin-bottom: 0px;
    }

    .disable-resize textarea {
        resize: none;
        white-space: pre-wrap !important;
    }

    .text_field textarea {
        padding-right: 60px;
    }

    @media (min-width: 1025px) {
        .mdc-text-field {
            width: 410px;
        }
    }

    /* Tablet Mode
    *******************************************************/
    @media (min-width: 769px) and (max-width: 1024px) {
        .mdc-text-field {
            /*width: 100%;*/
            width: 410px;
        }
    }

    /* Mobile Mode
    *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {
        .mdc-text-field {
            /*width: 100%;*/
            width: 238px;
        }

        #invite_comment {
            width: 100%;
        }
    }


</style>
{#if single_row === false}
    <label id={id} class="mdc-text-field mdc-text-field--textarea text_field"
           class:disable-resize={disable_resize === true}
           style={`height: ${height}`}>
        {#if show_counter === true}
            <div class="mdc-text-field-character-counter">0 / {max_chars}</div>
        {/if}

        <textarea bind:value={value}
                  class="mdc-text-field__input"
                  rows={rows}
                  cols={cols}
                  maxlength={max_chars}></textarea>

        <div class="mdc-notched-outline"
             class:mdc-notched-outline--upgraded={!!value}
             class:mdc-notched-outline--notched={!!value}>
            <div class="mdc-notched-outline__leading"></div>

            <div class="mdc-notched-outline__notch">
                <label
                       class="mdc-floating-label"
                       class:mdc-floating-label--float-above={!!value}>
                    {label}
                </label>
            </div>

            <div class="mdc-notched-outline__trailing"></div>
        </div>
    </label>
{:else}
    <label id={id} class="mdc-text-field mdc-text-field--textarea text_field"
           class:disable-resize={disable_resize === true}
           style={`width: ${width}; height: 55px`}>
        {#if show_counter === true}
            <div class="mdc-text-field-character-counter">0 / {max_chars}</div>
        {/if}

        <textarea bind:value={value}
                  class="mdc-text-field__input"
                  rows={rows}
                  cols={cols}
                  maxlength={max_chars}></textarea>

        <div class="mdc-notched-outline">
            <div class="mdc-notched-outline__leading"></div>

            <div class="mdc-notched-outline__notch">
                <label
                       class="mdc-floating-label">
                    {label}
                </label>
            </div>

            <div class="mdc-notched-outline__trailing"></div>
        </div>
    </label>
{/if}
